/** Fallback when API has not returned defaultAppName; real default is backend APP_NAME. */
const DEFAULT_APP_NAME = 'Ticket';

export const config = {
  defaultAppName: DEFAULT_APP_NAME,
  registeredTo: import.meta.env.VITE_APP_REGISTERED_TO || '',
  appVersion: import.meta.env.VITE_APP_VERSION || '1.0.0',
};
